import React from 'react';
import { StyledFlex } from '@goodfynd/styles';
import { Text } from '@goodfynd/ui';
import Skeleton from '@mui/material/Skeleton';

import { StyledColumnLeft, StyledColumnRight } from './styles';

export function CustomersOverviewLoading() {
  return (
    <StyledFlex>
      <StyledColumnLeft>
        <Text as="caption">
          <Skeleton width={100} />
        </Text>

        <Text as="heading2">
          <Skeleton width={31} />
        </Text>
        <Text
          as="caption"
          style={{
            alignItems: 'center',
            display: 'flex',
          }}
        >
          <Skeleton width={125} />
        </Text>

        <Text as="heading4" style={{ marginTop: 24 }}>
          <Skeleton width={50} />
        </Text>
        <Text as="caption">
          <Skeleton height={12 / 0.6} width={100} />
        </Text>

        <Text as="heading4" style={{ marginTop: 24 }}>
          <Skeleton height={12 / 0.6} width={65} />
        </Text>
        <Text as="caption">
          <Skeleton height={12 / 0.6} width={100} />
        </Text>
      </StyledColumnLeft>
      <StyledColumnRight>
        <Text as="caption">
          <Skeleton width={100} />
        </Text>

        <Text as="heading2">
          <Skeleton width={31} />
        </Text>
        <Text
          as="caption"
          style={{
            alignItems: 'center',
            display: 'flex',
          }}
        >
          <Skeleton width={125} />
        </Text>

        <Text as="heading4" style={{ marginTop: 24 }}>
          <Skeleton width={50} />
        </Text>
        <Text as="caption">
          <Skeleton height={12 / 0.6} width={100} />
        </Text>

        <Text as="heading4" style={{ marginTop: 24 }}>
          <Skeleton height={12 / 0.6} width={65} />
        </Text>
        <Text as="caption">
          <Skeleton height={12 / 0.6} width={100} />
        </Text>
      </StyledColumnRight>
    </StyledFlex>
  );
}
